module.exports = __webpack_public_path__ + "c37299e2f18a4bd9608cd99e18ee2c5c.png";